module.exports = __webpack_public_path__ + "fonts/obelixpro-broken-cyr-webfont.77f84f7e.woff2";